import { NavLink, Outlet } from 'react-router-dom';
import { cn } from '@/lib/classNames';

/**
 * Admin section shell — title + Users/Report tabs (the two header buttons in
 * the live Admin/index.php), with the active view rendered below.
 */
export function AdminLayout() {
  return (
    <div className="ast-cpl ast-admin">
      <div className="ast-page-head">
        <h2 className="serif ast-page-title">Admin</h2>
      </div>

      <nav className="ast-tabs">
        <NavLink end to="/admin" className={({ isActive }) => cn('ast-tab', isActive && 'active')}>
          <i className="bi bi-people me-1" /> Users
        </NavLink>
        <NavLink to="/admin/report" className={({ isActive }) => cn('ast-tab', isActive && 'active')}>
          <i className="bi bi-receipt me-1" /> Report
        </NavLink>
      </nav>

      <Outlet />
    </div>
  );
}
